import React from 'react';
import { ElfLanding } from '../components/landing';

/**
 * Home — the public ELF-CIRCLE landing page.
 *
 * Signed-in users keep reaching the app through /dashboard; `/` is the
 * marketing surface for everyone.
 */
const MainPage: React.FC = () => <ElfLanding />;

export default MainPage;
